import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Apply persisted theme (light/dark) before first paint to avoid a flash.
document.documentElement.setAttribute("data-theme", localStorage.getItem("bo_theme") || "light");

// Silence the benign "ResizeObserver loop" error that Radix triggers — in dev it
// pops the CRA overlay over the app after opening dialogs/selects.
const roLoop = /ResizeObserver loop (completed with undelivered notifications|limit exceeded)/;
window.addEventListener("error", (e) => { if (e.message && roLoop.test(e.message)) { e.stopImmediatePropagation(); e.preventDefault(); } }, true);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
